var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4521 9.00586V18.7559C20.4521 21.7559 18.6621 22.7559 16.4521 22.7559H8.45215C6.24215 22.7559 4.45215 21.7559 4.45215 18.7559V9.00586C4.45215 5.75586 6.24215 5.00586 8.45215 5.00586C8.45215 5.62586 8.70212 6.18586 9.11212 6.59586C9.52212 7.00586 10.0821 7.25586 10.7021 7.25586H14.2021C15.4421 7.25586 16.4521 6.24586 16.4521 5.00586C18.6621 5.00586 20.4521 5.75586 20.4521 9.00586Z",
    stroke: "#1E729F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4521 5.00586C16.4521 6.24586 15.4421 7.25586 14.2021 7.25586H10.7021C10.0821 7.25586 9.52212 7.00586 9.11212 6.59586C8.70212 6.18586 8.45215 5.62586 8.45215 5.00586C8.45215 3.76586 9.46215 2.75586 10.7021 2.75586H14.2021C14.8221 2.75586 15.3822 3.00586 15.7922 3.41586C16.2022 3.82586 16.4521 4.38586 16.4521 5.00586Z",
    stroke: "#1E729F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45215 13.7559H12.4521",
    stroke: "#1E729F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45215 17.7559H16.4521",
    stroke: "#1E729F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNote);
export default __webpack_public_path__ + "static/media/iconNote.53823c822c61a745ccdfc936a32db81a.svg";
export { ForwardRef as ReactComponent };